var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "row my-1" }, [
          _c("div", { staticClass: "col-2" }, [
            _vm._v(_vm._s(_vm.$t("testEquipment.abstract.id")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", disabled: "disabled" },
              domProps: { value: _vm.data.id > 0 ? _vm.data.id : "" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row my-1" }, [
          _c("div", { staticClass: "col-2" }, [
            _vm._v(_vm._s(_vm.$t("testEquipment.abstract.name")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.name,
                  expression: "data.name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.data.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.data, "name", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }